import { render, staticRenderFns } from "./BlogTagsSelector.vue?vue&type=template&id=5b48b515&"
import script from "./BlogTagsSelector.vue?vue&type=script&lang=js&"
export * from "./BlogTagsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports